import * as React from 'react';
export const EmptyIllustration = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={318} height={182} fill="none">
    <g clipPath="url(#a)">
      <path
        fill="#BEEFF3"
        d="M0 158.64C0 71.03 71.03 0 158.64 0c87.61 0 158.64 71.03 158.64 158.64H0Z"
      />
      <path
        fill="#6E56E6"
        d="M184.79 150.21c-2.84 0-5.67-1.03-7.9-3.08l-34.67-31.93 15.69-18.6 27 26.22 21.2-18.93 15.53 17.4-29.09 25.97a11.606 11.606 0 0 1-7.77 2.96l.01-.01Z"
      />
      <path
        fill="#fff"
        d="M69.96 68.67c-.7.01-1.37.16-1.98.43-1.41-6.18-6.98-10.74-13.56-10.64-7.57.11-13.61 6.34-13.49 13.91 0 .65.07 1.28.16 1.9l23.79-.36 3.34-.05 6.98-.1a5.158 5.158 0 0 0-5.23-5.08l-.01-.01Z"
      />
      <path
        fill="#6E56E6"
        d="M78.34 111.27S70 134.75 99.17 146.4c29.17 11.65 21.96-32.09 21.96-32.09l-42.79-3.04Z"
      />
      <path
        fill="#fff"
        d="M262.8 129.57c.16 0 .32.01.47.02.53-7.76 6.98-13.91 14.88-13.92 6.72-.01 12.41 4.4 14.31 10.49.78-.26 1.6-.42 2.47-.42 4.25 0 7.71 3.43 7.72 7.68 0 .58-.07 1.14-.19 1.69l-10.01.02h-5.01l-19 .05h-4.49l-6.77.02c0-3.11 2.51-5.64 5.62-5.64v.01Z"
      />
      <path
        fill="#C17742"
        d="M90.92 53.71c-1.77-6.97 2.45-14.06 9.42-15.83 2.1-.529 4.21-.509 6.19-.049.73-4.2 3.84-7.79 8.24-8.91 5.97-1.52 12.05 2.1 13.56 8.07.09.35.15.69.2 1.04h.01c.5 3.31 1.82 4.52 2.33 4.87.05.03.1.06.15.1.03.02.05.03.05.03h-.01c1.21.82 2.15 2.06 2.53 3.58a6.15 6.15 0 0 1-4.45 7.48c-3.29.83-18.34 19.66-21.64 20.49a6.15 6.15 0 0 1-7.48-4.45c-.66-2.6.45-5.23 2.57-6.64-5.44-.4-10.25-4.2-11.67-9.78Z"
      />
      <path
        fill="#F4BAAF"
        d="M100 38.73c5.37-5 15.24-3.52 24.08 2.95.3.22.59.44.88.67.09.07.18.15.28.22.22.17.44.35.65.53.09.08.19.16.28.23.28.23.55.47.83.71.02.02.04.04.06.05.29.26.59.53.88.8.08.08.17.16.25.24.22.21.44.42.65.64l.24.24a35.29 35.29 0 0 1 1.67 1.79c.11.12.21.24.31.36.16.19.32.37.48.56.12.15.24.29.36.44.13.16.26.33.39.49.12.16.25.31.37.47.03.03.05.07.08.1 7.58 10.02 9.16 21.57 3.23 27.09-1.55 1.45-3.48 2.35-5.65 2.75-1.98.36-4.17.31-6.46-.15L99.92 60.57l.14-.4c-.76-.8-1.08-1.39-1.08-1.39-3.67-7.96-3.56-15.81 1.01-20.07l.01.02Z"
      />
      <path
        fill="#582917"
        d="m112.611 54.29 3.917-6.583a.47.47 0 0 0-.163-.645l-1.135-.675a.47.47 0 0 0-.644.164l-3.918 6.582a.47.47 0 0 0 .164.645l1.134.675c.223.132.512.06.645-.164Z"
      />
      <path
        fill="#CD8071"
        d="M117.35 67.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM127.77 59.12l2.56-4.63c.22-.4.05-.91-.37-1.1l-8.7-3.78 6.51 9.51Z"
      />
      <path
        fill="#582917"
        d="M118.01 55.72a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7ZM128.08 50.39a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7Z"
      />
      <path
        fill="#C17742"
        d="m97.44 39.61 2.1-1.47c-.91-5.01 2.2-9.94 7.21-11.21 5.23-1.33 10.55 1.84 11.88 7.07s-1.84 10.55-7.07 11.88a9.6 9.6 0 0 1-2.3.29c-1.61.27-3.22.49-4.54.98.98 2.51 4.14 11.4 1.66 16.42-2.91 5.9-13.14-10.79-13.14-10.79l4.2-13.17Z"
      />
      <path
        fill="#582917"
        d="m122.745 45.696 7.675.278a.46.46 0 0 0 .476-.443l.052-1.42a.46.46 0 0 0-.443-.476l-7.675-.277a.461.461 0 0 0-.477.443l-.051 1.419a.46.46 0 0 0 .443.476Z"
      />
      <path
        fill="#F4BAAF"
        d="m104.04 65.28 23.32 10.94 2.31 9.9c.53 2.35-3.34 3.71-8.53 5.02-5.17 1.3-11.17-1.52-11.85-3.81l-.54-1.5-4.7-20.55h-.01Z"
      />
      <path
        stroke="#CD8071"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={0.85}
        d="M127.86 80.3c-1.37.08-4.28.02-6.37-.43-.11-.02-.22-.05-.33-.07"
      />
      <path
        fill="#F4BAAF"
        d="M103.84 70.24a6.14 6.14 0 1 0 0-12.279 6.14 6.14 0 0 0 0 12.28Z"
      />
      <path
        stroke="#CE8071"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={0.85}
        d="m101.7 63.52 1.49-1s.44-.28.74-.25c.32.03.42.51.27.96-.57 1.79-.04 2.43.7 2.5"
      />
      <path
        fill="#582917"
        d="M132 67.56c.07-.12.15-.24.2-.37-.06.13-.13.25-.2.37ZM131.25 68.35c.12-.08.23-.17.33-.26-.1.1-.22.18-.33.26ZM131.66 67.99ZM126.96 66.69c-.29-1.33.41-2.7 1.72-3.19 1.43-.54 3.03.19 3.57 1.62.26.69.22 1.42-.05 2.05-1.7-1.95-4.41-.88-5.25-.48h.01Z"
      />
      <path
        fill="#E883C3"
        d="M131.14 68.43s.07-.06.11-.08c-.04.03-.07.06-.11.08ZM132.21 67.17s0 .01-.01.02v-.02h.01ZM131.58 68.09s.05-.07.08-.1c-.03.03-.05.07-.08.1ZM126.95 66.69c.03.13.05.25.1.38-.05-.12-.08-.25-.11-.37l.01-.01ZM131.94 67.66s.04-.07.06-.11c-.02.04-.04.07-.06.11Z"
      />
      <path
        fill="#E883C3"
        d="M127.06 67.07c-.05-.12-.07-.25-.1-.38.84-.4 3.55-1.47 5.25.48v.02c-.06.13-.13.25-.2.37-.02.04-.04.07-.06.11-.08.12-.17.22-.27.32-.03.03-.05.07-.08.1-.1.1-.22.18-.33.26-.04.03-.07.06-.11.08-.16.1-.33.19-.51.26-1.43.54-3.03-.19-3.57-1.62h-.02Z"
      />
      <path
        fill="#fff"
        d="M236.64 51.97h-58.62a8.15 8.15 0 0 0-8.15 8.15v82.961a8.15 8.15 0 0 0 8.15 8.15h58.62a8.15 8.15 0 0 0 8.15-8.15v-82.96a8.15 8.15 0 0 0-8.15-8.15Z"
      />
      <path
        fill="#023F88"
        d="M176.03 66.12a6.03 6.03 0 0 1 6.03-6.03c3.32 0 6.03 2.71 6.03 6.03 0 3.32-2.71 6.03-6.03 6.03-3.32.02-6.03-2.69-6.03-6.03Z"
      />
      <path
        fill="#fff"
        d="M182.21 62.39c0-.2.17-.37.37-.37.2 0 .37.17.37.37 0 .2-.17.37-.37.37-.2.02-.37-.15-.37-.37ZM183.38 63.67c0-.22.19-.41.41-.41.22 0 .41.19.41.41 0 .22-.19.41-.41.41-.22 0-.41-.19-.41-.41ZM182.21 63.67c0-.2.17-.37.37-.37.2 0 .37.17.37.37 0 .2-.17.37-.37.37-.2 0-.37-.17-.37-.37ZM184.62 64.93c0-.26.2-.46.46-.46s.46.2.46.46-.2.46-.46.46c-.24 0-.46-.2-.46-.46ZM183.38 64.93c0-.22.19-.41.41-.41.22 0 .41.19.41.41 0 .22-.19.41-.41.41-.22 0-.41-.19-.41-.41ZM182.21 64.93c0-.2.17-.37.37-.37.2 0 .37.17.37.37 0 .2-.17.37-.37.37-.2 0-.37-.17-.37-.37ZM181.08 64.93c0-.19.15-.33.33-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33-.19 0-.33-.15-.33-.33ZM180.15 64.93c0-.15.13-.28.28-.28.15 0 .28.13.28.28 0 .15-.13.28-.28.28-.15 0-.28-.13-.28-.28ZM179.26 64.93c0-.13.11-.24.24-.24s.24.11.24.24-.11.24-.24.24-.24-.11-.24-.24ZM178.5 64.93a.19.19 0 1 1 .19.19c-.1 0-.19-.07-.19-.19ZM177.79 64.93c0-.07.06-.15.15-.15.07 0 .15.06.15.15 0 .07-.06.15-.15.15s-.15-.07-.15-.15ZM177.18 64.93c0-.06.04-.09.09-.09.05 0 .09.04.09.09 0 .05-.04.09-.09.09-.04 0-.09-.04-.09-.09ZM184.62 66.19c0-.26.2-.46.46-.46s.46.2.46.46-.2.46-.46.46c-.24.02-.46-.2-.46-.46ZM183.38 66.19c0-.22.19-.41.41-.41.22 0 .41.19.41.41 0 .22-.19.41-.41.41-.22.02-.41-.17-.41-.41ZM182.21 66.19c0-.2.17-.37.37-.37.2 0 .37.17.37.37 0 .2-.17.37-.37.37-.2.02-.37-.15-.37-.37ZM181.08 66.19c0-.19.15-.33.33-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33-.18 0-.33-.15-.33-.33ZM180.15 66.19c0-.15.13-.28.28-.28.15 0 .28.13.28.28 0 .15-.13.28-.28.28-.15.02-.28-.11-.28-.28ZM179.26 66.19c0-.13.11-.24.24-.24s.24.11.24.24-.11.24-.24.24-.24-.11-.24-.24ZM178.5 66.19a.19.19 0 1 1 .19.19c-.1 0-.19-.07-.19-.19ZM177.79 66.19c0-.07.06-.15.15-.15.07 0 .15.06.15.15 0 .07-.06.15-.15.15s-.15-.06-.15-.15ZM177.18 66.19c0-.06.04-.09.09-.09.05 0 .09.04.09.09 0 .05-.04.09-.09.09-.04 0-.09-.04-.09-.09ZM185.91 66.21c0-.28.22-.52.52-.52.28 0 .52.22.52.52 0 .28-.22.52-.52.52a.53.53 0 0 1-.52-.52ZM184.62 67.48c0-.26.2-.46.46-.46s.46.2.46.46-.2.46-.46.46c-.24 0-.46-.2-.46-.46ZM183.38 67.48c0-.22.19-.41.41-.41.22 0 .41.19.41.41 0 .22-.19.41-.41.41-.22 0-.41-.19-.41-.41ZM182.21 67.48c0-.2.17-.37.37-.37.2 0 .37.17.37.37 0 .2-.17.37-.37.37-.2 0-.37-.17-.37-.37ZM181.08 67.48c0-.19.15-.33.33-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33-.19-.02-.33-.17-.33-.33ZM180.15 67.48c0-.15.13-.28.28-.28.15 0 .28.13.28.28 0 .15-.13.28-.28.28-.15 0-.28-.13-.28-.28ZM179.26 67.48c0-.13.11-.24.24-.24s.24.11.24.24-.11.24-.24.24c-.13-.02-.24-.11-.24-.24ZM178.5 67.48a.19.19 0 1 1 .19.19c-.1 0-.19-.09-.19-.19ZM177.79 67.48c0-.07.06-.15.15-.15.07 0 .15.06.15.15 0 .07-.06.15-.15.15-.09-.02-.15-.07-.15-.15ZM177.18 67.48c0-.06.04-.09.09-.09.05 0 .09.04.09.09 0 .05-.04.09-.09.09-.04 0-.09-.06-.09-.09ZM183.38 68.74c0-.22.19-.41.41-.41.22 0 .41.19.41.41 0 .22-.19.41-.41.41-.22 0-.41-.19-.41-.41ZM182.21 68.74c0-.2.17-.37.37-.37.2 0 .37.17.37.37 0 .2-.17.37-.37.37-.2 0-.37-.17-.37-.37ZM182.21 70c0-.2.17-.37.37-.37.2 0 .37.17.37.37 0 .2-.17.37-.37.37-.2.02-.37-.17-.37-.37Z"
      />
      <mask
        id="b"
        width={318}
        height={159}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 158.64C0 71.03 71.03 0 158.64 0c87.61 0 158.64 71.03 158.64 158.64H0Z"
        />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#6E56E6"
          d="M91.19 181.51h70.47l-2.75-78.33-81.66 14.29 13.94 64.04Z"
        />
        <path
          stroke="#503DC9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.86}
          d="m142.44 132.15-20.94 9.86-13.98-20.49"
        />
        <g clipPath="url(#c)">
          <path
            fill="#F4BAAF"
            d="M180.149 141.158s2.929-.673 4.444-1.333c2.502-1.093 2.222-4.473-.407-4.459 3.209-1.276 1.729-5.397-1.488-4.614 2.425-1.085 1.612-4.786-1.657-4.317-2.368.341-15.665 3.089-15.416 2.871 1.709-1.573 3.306-2.944 3.731-4.235.591-1.791-1.426-3.541-3.164-2.329-2.855 1.988-6.127 4.571-8.506 6.354-1.188.895-2.537 3.274-3.068 5.26l-6.499 2.908c-1.538.768-1.538 4.158.013 7.644 1.565 3.497 4.103 5.778 5.698 5.117l.03-.013 5.663-2.534c1.305 1.19 2.679 1.525 5.166 1.291 3.05-.283 9.254-1.808 9.254-1.808s2.176-.53 6.199-1.834c2.25-.723 2.184-3.666-.004-3.974l.011.005Z"
          />
          <path
            stroke="#CE8071"
            strokeLinecap="round"
            strokeMiterlimit={10}
            strokeWidth={0.81}
            d="m182.369 130.73-9.77 2.083M183.8 135.414l-10.239 2.107M179.518 141.252l-5.436 1.12"
          />
        </g>
        <path
          stroke="#6E56E6"
          strokeLinejoin="round"
          strokeWidth={13.32}
          d="m91.77 118.039 23.87 40.64 35.39-16.38"
        />
        <path
          stroke="#503DC9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.86}
          d="m84.48 133.6 21.35 32.52a12.267 12.267 0 0 0 15.67 3.73l34.52-16.31-.99-3.26"
        />
      </g>
      <mask
        id="d"
        width={318}
        height={159}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 158.64C0 71.03 71.03 0 158.64 0c87.61 0 158.64 71.03 158.64 158.64H0Z"
        />
      </mask>
      <g mask="url(#d)">
        <path
          fill="#6E56E6"
          d="M91.19 181.51h70.47l-2.75-78.33-81.66 14.29 13.94 64.04Z"
        />
        <path
          stroke="#503DC9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.86}
          d="m142.44 132.15-20.94 9.86-13.98-20.49"
        />
        <g clipPath="url(#e)">
          <path
            fill="#F4BAAF"
            d="M180.149 141.158s2.929-.673 4.444-1.333c2.502-1.093 2.222-4.473-.407-4.459 3.209-1.276 1.729-5.397-1.488-4.614 2.425-1.085 1.612-4.786-1.657-4.317-2.368.341-15.665 3.089-15.416 2.871 1.709-1.573 3.306-2.944 3.731-4.235.591-1.791-1.426-3.541-3.164-2.329-2.855 1.988-6.127 4.571-8.506 6.354-1.188.895-2.537 3.274-3.068 5.26l-6.499 2.908c-1.538.768-1.538 4.158.013 7.644 1.565 3.497 4.103 5.778 5.698 5.117l.03-.013 5.663-2.534c1.305 1.19 2.679 1.525 5.166 1.291 3.05-.283 9.254-1.808 9.254-1.808s2.176-.53 6.199-1.834c2.25-.723 2.184-3.666-.004-3.974l.011.005Z"
          />
          <path
            stroke="#CE8071"
            strokeLinecap="round"
            strokeMiterlimit={10}
            strokeWidth={0.81}
            d="m182.369 130.73-9.77 2.083M183.8 135.414l-10.239 2.107M179.518 141.252l-5.436 1.12"
          />
        </g>
        <path
          stroke="#6E56E6"
          strokeLinejoin="round"
          strokeWidth={13.32}
          d="m91.77 118.039 23.87 40.64 35.39-16.38"
        />
        <path
          stroke="#503DC9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.86}
          d="m84.48 133.6 21.35 32.52a12.267 12.267 0 0 0 15.67 3.73l34.52-16.31-.99-3.26"
        />
      </g>
      <mask
        id="f"
        width={318}
        height={159}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 158.64C0 71.03 71.03 0 158.64 0c87.61 0 158.64 71.03 158.64 158.64H0Z"
        />
      </mask>
      <g mask="url(#f)">
        <path
          fill="#6E56E6"
          d="M91.19 181.51h70.47l-2.75-78.33-81.66 14.29 13.94 64.04Z"
        />
        <path
          stroke="#503DC9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.86}
          d="m142.44 132.15-20.94 9.86-13.98-20.49"
        />
        <g clipPath="url(#g)">
          <path
            fill="#F4BAAF"
            d="M180.149 141.158s2.929-.673 4.444-1.333c2.502-1.093 2.222-4.473-.407-4.459 3.209-1.276 1.729-5.397-1.488-4.614 2.425-1.085 1.612-4.786-1.657-4.317-2.368.341-15.665 3.089-15.416 2.871 1.709-1.573 3.306-2.944 3.731-4.235.591-1.791-1.426-3.541-3.164-2.329-2.855 1.988-6.127 4.571-8.506 6.354-1.188.895-2.537 3.274-3.068 5.26l-6.499 2.908c-1.538.768-1.538 4.158.013 7.644 1.565 3.497 4.103 5.778 5.698 5.117l.03-.013 5.663-2.534c1.305 1.19 2.679 1.525 5.166 1.291 3.05-.283 9.254-1.808 9.254-1.808s2.176-.53 6.199-1.834c2.25-.723 2.184-3.666-.004-3.974l.011.005Z"
          />
          <path
            stroke="#CE8071"
            strokeLinecap="round"
            strokeMiterlimit={10}
            strokeWidth={0.81}
            d="m182.369 130.73-9.77 2.083M183.8 135.414l-10.239 2.107M179.518 141.252l-5.436 1.12"
          />
        </g>
        <path
          stroke="#6E56E6"
          strokeLinejoin="round"
          strokeWidth={13.32}
          d="m91.77 118.039 23.87 40.64 35.39-16.38"
        />
        <path
          stroke="#503DC9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.86}
          d="m84.48 133.6 21.35 32.52a12.267 12.267 0 0 0 15.67 3.73l34.52-16.31-.99-3.26"
        />
      </g>
      <mask
        id="h"
        width={318}
        height={159}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 158.64C0 71.03 71.03 0 158.64 0c87.61 0 158.64 71.03 158.64 158.64H0Z"
        />
      </mask>
      <g mask="url(#h)">
        <path
          fill="#6E56E6"
          d="M91.19 181.51h70.47l-2.75-78.33-81.66 14.29 13.94 64.04Z"
        />
        <path
          stroke="#503DC9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.86}
          d="m142.44 132.15-20.94 9.86-13.98-20.49"
        />
        <g clipPath="url(#i)">
          <path
            fill="#F4BAAF"
            d="M180.149 141.158s2.929-.673 4.444-1.333c2.502-1.093 2.222-4.473-.407-4.459 3.209-1.276 1.729-5.397-1.488-4.614 2.425-1.085 1.612-4.786-1.657-4.317-2.368.341-15.665 3.089-15.416 2.871 1.709-1.573 3.306-2.944 3.731-4.235.591-1.791-1.426-3.541-3.164-2.329-2.855 1.988-6.127 4.571-8.506 6.354-1.188.895-2.537 3.274-3.068 5.26l-6.499 2.908c-1.538.768-1.538 4.158.013 7.644 1.565 3.497 4.103 5.778 5.698 5.117l.03-.013 5.663-2.534c1.305 1.19 2.679 1.525 5.166 1.291 3.05-.283 9.254-1.808 9.254-1.808s2.176-.53 6.199-1.834c2.25-.723 2.184-3.666-.004-3.974l.011.005Z"
          />
          <path
            stroke="#CE8071"
            strokeLinecap="round"
            strokeMiterlimit={10}
            strokeWidth={0.81}
            d="m182.369 130.73-9.77 2.083M183.8 135.414l-10.239 2.107M179.518 141.252l-5.436 1.12"
          />
        </g>
        <path
          stroke="#6E56E6"
          strokeLinejoin="round"
          strokeWidth={13.32}
          d="m91.77 118.039 23.87 40.64 35.39-16.38"
        />
        <path
          stroke="#503DC9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.86}
          d="m84.48 133.6 21.35 32.52a12.267 12.267 0 0 0 15.67 3.73l34.52-16.31-.99-3.26"
        />
      </g>
      <path
        fill="#6E56E6"
        d="M77.3 116.1c.54-6.82 3.45-13 7.89-17.36 10.02-9.82 25.86-13.11 25.86-13.11l4.84-.33 6.58-.45 4.84-.33s16.14 1.09 27.41 9.44c5 3.7 8.74 9.42 10.2 16.11l-87.16 6.02"
      />
      <path fill="#E05821" d="M94.84 87.58v.01l.01-.01h-.01Z" />
      <path
        fill="#F4BAAF"
        d="M131.59 85.05c-2.62-.43-4.28-.54-4.28-.54l-4.84.33-6.58.45-4.84.33s-1.63.34-4.17 1.12l14.85 9.89 9.86-11.6v.02Z"
      />
      <path
        fill="#503DC9"
        d="M121.73 96.65v-.01l-14.85-9.89 2.02 19.28 12.83-9.38Z"
      />
      <path
        fill="#503DC9"
        d="m121.74 96.64-.01.01 12.26 7.641-2.39-19.24h-.01l-9.86 11.59h.01Z"
      />
      <path
        stroke="#503DC9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.86}
        d="M158.73 114.301v13.35"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h317.28v181.51H0z" />
      </clipPath>
      <clipPath id="c">
        <path
          fill="#fff"
          d="m179.06 116.93 10.704 23.917-36.199 16.2-10.703-23.917z"
        />
      </clipPath>
      <clipPath id="e">
        <path
          fill="#fff"
          d="m179.06 116.93 10.704 23.917-36.199 16.2-10.703-23.917z"
        />
      </clipPath>
      <clipPath id="g">
        <path
          fill="#fff"
          d="m179.06 116.93 10.704 23.917-36.199 16.2-10.703-23.917z"
        />
      </clipPath>
      <clipPath id="i">
        <path
          fill="#fff"
          d="m179.06 116.93 10.704 23.917-36.199 16.2-10.703-23.917z"
        />
      </clipPath>
    </defs>
  </svg>
);
